angular.module('ihestiaRestServicesBase')

/**
   * Ustawienia
   * @return {[type]} [description]
   */
  .factory('IHestiaAbstractModel', [ 'LsnAbstractModel', function(LsnAbstractModel) {
    return LsnAbstractModel;
  }]);